import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(135deg, rgb(144 182 232 / 85%), rgb(37 88 153 / 85%)), url(${process.env.PUBLIC_URL}/hero-bg.jpg)`
  };

  return (
    <section className="hero" style={heroStyle}>
      <div className="container hero-content">
        <h2>Welcome to Fast Track College of Business, Healthcare and Technology</h2>
        <p>Empowering students with industry-focused education in Business, Healthcare, and Technology—designed to build practical skills, accelerate careers, and shape future professionals</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/admissions" className="btn btn-primary">Apply Now</Link>
          <Link to="/courses" className="btn btn-secondary">Explore Courses</Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
